import { render, staticRenderFns } from "./DashboardReservationsNoInvoice.vue?vue&type=template&id=195240d4&scoped=true&"
import script from "./DashboardReservationsNoInvoice.vue?vue&type=script&lang=js&"
export * from "./DashboardReservationsNoInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195240d4",
  null
  
)

export default component.exports